var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 34,
    width: 39,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7855302431170932,0,0,0.7687523028504214,91.72093306770546,92.32493254420888) ",
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    d: "m-93.848603,-120.727277a21.52,21.52 0 0 0 -21.5,21.5c1.18,28.52 41.82,28.51 43,0a21.52,21.52 0 0 0 -21.5,-21.5zm0,40a18.52,18.52 0 0 1 -18.5,-18.5c1,-24.54 36,-24.54 37,0a18.52,18.52 0 0 1 -18.5,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    d: "m-93.848603,-94.617277a1.5,1.5 0 0 0 1.5,-1.5l0,-12a1.5,1.5 0 0 0 -3,0l0,12a1.5,1.5 0 0 0 1.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    d: "m-93.848603,-92.527277a1.59,1.59 0 0 0 0,3.18a1.59,1.59 0 0 0 0,-3.18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.dfabec5616500c4a99294955c18463d0.svg";
export { ForwardRef as ReactComponent };